$(function () {
  $("#sign-up-modal").modal("show")
})